import { useState } from 'react'
import {
  Container,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  FormControl,
  FormLabel,
} from '@material-ui/core';

import { ToggleButtonGroup, ToggleButton } from '@mui/material';

import { platformId } from './config.js';

export default function PersonalityForm({chatHost, avatarUrl}) {
  const [mbtiType, setMBTIType] = useState('ENTJ');

  const mbtiTypes = [
    ["EI", "Extrovert", "Introvert", "How I direct and receive energy — either outwardly towards people and activities (E) or inwardly towards thoughts and ideas (I)."],
    ["NS", "Intuitive", "Sensing", "How I gather information — either by focusing on tangible and present details (S) or by looking at patterns and future possibilities (N)."],
    ["TF", "Thinking", "Feeling", "How I make decisions — either through logical analysis (T) or by considering personal values and the feelings of others (F)."],
    ["JP", "Judging", "Perceiving", "How I approach the external world — either with a structured and planned manner (J) or with a flexible and spontaneous approach (P)."],
  ];

  function onMBTIChange(idx, newVal) {
    let newType = mbtiType.substring(0, idx) + newVal + mbtiType.substring(idx+1,4);
    console.log(idx);
    setMBTIType(newType);
    document.getElementById('mbti').value = mbtiType;
    console.log(mbtiType);
    return true;
  }

  const platformSuffix = platformId ? `?platformId=${platformId}`: '';
  const submitUrl = `${chatHost}/submit-user-profile${platformSuffix}`;


  return (
    <Container component="main" maxWidth="xs">
      <Typography variant="h5">Tell Us About Yourself</Typography>

      <form noValidate action={submitUrl} method="post">
        <input type="hidden" name="redirect" value={avatarUrl}/>
        <input type="hidden" name="user_agent" value={navigator.userAgent}/>
        <input type="hidden" id="mbti" name="mbti" value={mbtiType}/>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="name"
          label="Name"
          name="name"
          autoComplete="name"
        />

        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoComplete="email"
        />
{/* 
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="age"
          label="Age"
          type="number"
          id="age"
        /> */}

        <FormControl key="1" component="fieldset" fullWidth margin="normal">
          <FormLabel component="legend">Gender</FormLabel>
          <RadioGroup row aria-label="gender" name="gender">
            <FormControlLabel value="male" control={<Radio required />} label="Male" />
            <FormControlLabel value="female" control={<Radio required />} label="Female" />
          </RadioGroup>
        </FormControl>


        <FormControl key="2" component="fieldset" fullWidth margin="normal">
          <FormLabel>Meyers-Briggs Type</FormLabel>
        
        {mbtiTypes.map((mbti, idx) => {
          return (
            <div style={{marginTop: '20px'}}>
              <FormLabel key={idx} color="secondary" style={{fontSize: '80%'}}>{mbti[3]}</FormLabel>
              <ToggleButtonGroup
                color="primary"
                exclusive
                aria-label={'mbti'+idx}
                name={'mbti-group-'+idx}
                id={'mbti-group-'+idx}
                key={idx}
                value={mbtiType[idx]}
                onChange={(event, newVal) => onMBTIChange(idx, newVal)}
                fullWidth
              >
                <ToggleButton key={''+idx+'a'} sx={{ width: '50%' }} value={mbti[0][0]}>{mbti[1]}</ToggleButton>
                <ToggleButton key={''+idx+'b'} sx={{ width: '50%' }} value={mbti[0][1]}>{mbti[2]}</ToggleButton>
              </ToggleButtonGroup>
            </div>
          )
        })}
        </FormControl>

        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="about"
          label="Anything else you'd like to say about yourself"
          multiline
          id="about"
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          style={{ margin: '24px 0' }}
        >
          Submit
        </Button>
      </form>
    </Container>
  );
}

// // To use:
// import React from 'react';
// import ReactDOM from 'react-dom';
// import PersonalityForm from './PersonalityForm';

// ReactDOM.render(<PersonalityForm />, document.getElementById('root'));